const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    image,
    variant,
    margin,
    titleCard,
    numberCard,
    removeImage,
    sizeImage,
    hAlign,
    textAfter,
    variantColored,
    background,
    originalSize,
    marginImage,
    anchor,
    hasNumber,
  } = attributes;

  var hasAnchor = false;

  if (variant === 'withTopicsExtended' || variant === 'coverWithText') {
    var style = {
      background: `url(${image.src}) no-repeat`,
      backgroundSize: 'cover',
    };
  }

  if (variant === 'coverWithText' && anchor) {
    hasAnchor = true;
  }

  return (
    <div
      className={`
        Card-col-item
        ${variant}
        ${margin} 
        ${hAlign}
        ${textAfter ? 'textAfter' : ''}
        ${variant === 'titleColored' ? variantColored : ''}
        ${variant === 'bgColored' && background}
        ${variant == 'circular' ? hasNumber === true ? 'hasNumber' : 'withoutNumber' : ''}
      `}
      data-anchor={`${variant === 'coverWithText' ? anchor : ''}`}
    >
      {variant === 'withTopicsExtended' ||
      variant === 'coverWithText' ||
      variant === 'titleColored' ? (
        <div className="Card-col-item-image" style={style}>
          <RichText.Content
            className="Card-col-item-title"
            tagName="h3"
            value={titleCard}
          />
        </div>
      ) : image.src && !removeImage && variant != 'circular' ? (
        <figure
          className={`
            Card-col-item-image
            ${marginImage}
            ${variant === 'bordered' && (originalSize ? 'originalSize' : '')}
            ${sizeImage === 'normal' ? 'imgNormal' : sizeImage === 'big' ? 'imgBig' : ''}
          `}
        >
          <img
            src={image.src}
            title={image.alt}
            width={image.width}
            height={image.height}
            alt={image.alt}
          />
        </figure>
      ) : (
        variant === 'circular' && hasNumber && (
          <div className="Card-col-item-circle">
            <RichText.Content
              className="Card-col-item-number"
              tagName="p"
              value={numberCard}
            />
          </div>
        )
      )}

      {variant != 'coverWithText' && (
        <div className="Card-col-item-text">
          <InnerBlocks.Content />
        </div>
      )}
    </div>
  );
};

export default Save;
